import axiosClient from "../axiosClient";
import { Webinaire } from "../interfaces/webinaire.interface";

export const findAllWebinaires = async (): Promise<Webinaire[]> => {
  const response = await axiosClient.get<Webinaire[]>("/webinaires");
  return response.data;
};
